module.exports = __webpack_public_path__ + "bb23ed5a4dab912be73a2172933926dc.svg";